var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204-129q-30.94 0-52.97-22.03Q129-173.06 129-204v-552q0-30.94 22.03-52.97Q173.06-831 204-831h264q18.75 0 28.13 11.5 9.37 11.5 9.37 25.75t-9.73 26Q486.04-756 467.5-756H204v552h552v-265q0-18.75 11.72-28.13 11.72-9.37 25.78-9.37 14.5 0 26 9.37Q831-487.75 831-469v265q0 30.94-22.03 52.97Q786.94-129 756-129H204Zm276-351Zm-117.5 80v-98q0-15.14 5.74-28.87 5.74-13.72 16.26-24.13L731-897.5q11.5-11.5 25-16.75t27.77-5.25q15.23 0 28.73 5.25t25 16.75L897-837q10.5 11.5 16 25t5.5 28q0 14.5-5 27.75T897-731.5L551-385q-10.41 10.31-24.13 16.41-13.73 6.09-28.87 6.09h-98q-15.5 0-26.5-11t-11-26.5Zm482-384-60-60.5 60 60.5Zm-407 346.5h60l234.5-235-30-30-30.5-29.5-234 233.5v61Zm264.5-265L671.5-732l30.5 29.5 30 30-30-30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit-square.84dc318366c87cb1bb86336b14bf35f3.svg";
export { ForwardRef as ReactComponent };